import Accordion from './Accordion.js';
import AccordionItem from './AccordionItem.js';
Accordion.config.components = {
  AccordionItem: AccordionItem
};
export default Accordion;
//# sourceMappingURL=index.js.map